import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Tools\Pdf\ReorderPdfController::pageCount
* @see Http/Controllers/Tools/Pdf/ReorderPdfController.php:24
* @route '/{locale}/tools/pdf/reorder/page-count'
*/
export const pageCount = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: pageCount.url(args, options),
    method: 'post',
})

pageCount.definition = {
    methods: ["post"],
    url: '/{locale}/tools/pdf/reorder/page-count',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Tools\Pdf\ReorderPdfController::pageCount
* @see Http/Controllers/Tools/Pdf/ReorderPdfController.php:24
* @route '/{locale}/tools/pdf/reorder/page-count'
*/
pageCount.url = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { locale: args }
    }

    if (Array.isArray(args)) {
        args = {
            locale: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        locale: args.locale,
    }

    return pageCount.definition.url
            .replace('{locale}', parsedArgs.locale.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tools\Pdf\ReorderPdfController::pageCount
* @see Http/Controllers/Tools/Pdf/ReorderPdfController.php:24
* @route '/{locale}/tools/pdf/reorder/page-count'
*/
pageCount.post = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: pageCount.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\ReorderPdfController::pageCount
* @see Http/Controllers/Tools/Pdf/ReorderPdfController.php:24
* @route '/{locale}/tools/pdf/reorder/page-count'
*/
const pageCountForm = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: pageCount.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\ReorderPdfController::pageCount
* @see Http/Controllers/Tools/Pdf/ReorderPdfController.php:24
* @route '/{locale}/tools/pdf/reorder/page-count'
*/
pageCountForm.post = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: pageCount.url(args, options),
    method: 'post',
})

pageCount.form = pageCountForm

/**
* @see \App\Http\Controllers\Tools\Pdf\ReorderPdfController::submit
* @see Http/Controllers/Tools/Pdf/ReorderPdfController.php:50
* @route '/{locale}/tools/pdf/reorder'
*/
export const submit = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: submit.url(args, options),
    method: 'post',
})

submit.definition = {
    methods: ["post"],
    url: '/{locale}/tools/pdf/reorder',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Tools\Pdf\ReorderPdfController::submit
* @see Http/Controllers/Tools/Pdf/ReorderPdfController.php:50
* @route '/{locale}/tools/pdf/reorder'
*/
submit.url = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { locale: args }
    }

    if (Array.isArray(args)) {
        args = {
            locale: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        locale: args.locale,
    }

    return submit.definition.url
            .replace('{locale}', parsedArgs.locale.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tools\Pdf\ReorderPdfController::submit
* @see Http/Controllers/Tools/Pdf/ReorderPdfController.php:50
* @route '/{locale}/tools/pdf/reorder'
*/
submit.post = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: submit.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\ReorderPdfController::submit
* @see Http/Controllers/Tools/Pdf/ReorderPdfController.php:50
* @route '/{locale}/tools/pdf/reorder'
*/
const submitForm = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: submit.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\ReorderPdfController::submit
* @see Http/Controllers/Tools/Pdf/ReorderPdfController.php:50
* @route '/{locale}/tools/pdf/reorder'
*/
submitForm.post = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: submit.url(args, options),
    method: 'post',
})

submit.form = submitForm

const reorder = {
    pageCount: Object.assign(pageCount, pageCount),
    submit: Object.assign(submit, submit),
}

export default reorder